import { Lock } from "lucide-react";
import { PLAN_FEATURES, PLAN_TIER_DEFAULTS } from "@clevis/shared-types";
import { Card, cn } from "@clevis/shared-ui";

// Shown where a feature isn't in the company's plan: what it is, which plan
// has it, and who can change plans. Never a popup; never an upsell banner
// elsewhere (the product rule): only on the thing they reached for.

export function planOf(key: string): string {
  const f = PLAN_FEATURES.find((x) => x.key === key);
  return f ? PLAN_TIER_DEFAULTS[f.tier].name : "a higher";
}

export function PlanLocked({ feature, page = false, className }: { feature: string; page?: boolean; className?: string }) {
  const f = PLAN_FEATURES.find((x) => x.key === feature);
  const label = f?.label.split(":")[0] ?? "This";
  const body = (
    <div className={cn("flex items-start gap-2 text-sm", className)}>
      <Lock size={15} className="mt-0.5 shrink-0 text-steel" />
      <div>
        <div className="font-semibold text-ink">{label} is part of the {planOf(feature)} plan.</div>
        <div className="text-xs text-steel">The owner can change plans under Setup → Billing.</div>
      </div>
    </div>
  );
  return page ? <div className="mx-auto max-w-md py-16">{body}</div> : <Card className="bg-cream/40">{body}</Card>;
}
